/**
 * app/screens/MaintenanceScreen.tsx
 * ----------------------------------
 * What: Screen shown when maintenance mode is enabled via remote config.
 * Why: Communicates temporary unavailability with a friendly message.
 */
import React from 'react';
import { SafeAreaView, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../lib/ThemeContext';

export default function MaintenanceScreen() {
  const { theme } = useTheme();
  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}> 
      <Ionicons name="construct" size={64} color={theme.success} style={styles.icon} />
      <Text style={[styles.title, { color: theme.text }]}>It's not you, it's us.</Text>
      <Text style={[styles.message, { color: theme.secondaryText }]}>We're making some exciting (or mundane!) changes.
        {"\n"}Please check back soon!
        {"\n"}We won't be long
      </Text>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 32,
  },
  icon: {
    marginBottom: 24,
  },
  title: {
    fontSize: 22,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 12,
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
  },
}); 